module.exports = __webpack_public_path__ + "static/fonts/FANGZHENGKAITIFANTI-1_0.ea7835b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/suft/FANGZHENGKAITIFANTI-1_0.woff
// module id = AdBn
// module chunks = 2